type KeyObject = {
  [key: string]: any;
};

export const getObjectFieldPaths = (obj: KeyObject): string[] => {
  const fieldPaths: string[] = [];

  const traverse = (currentObj: KeyObject, currentPath: string): void => {
    if (currentObj) {
      Object.keys(currentObj).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(currentObj, key)) {
          const newPath = currentPath ? `${currentPath}.${key}` : key;

          if (typeof currentObj[key] === 'object') {
            traverse(currentObj[key], newPath);
          } else {
            fieldPaths.push(newPath);
          }
        }
      });
    }
  };

  traverse(obj, '');
  return fieldPaths;
};
